import {
  ContactsMiniCard,
  DevelopmentsMiniCard,
  PropertiesMiniCard,
} from '../../DashboardMiniCards/instances';
import ContactSource from '../RowCards/ContactSource';
import PendingScheduledEvents from '../RowCards/PendingScheduledEvents';
import OverviewLeads from '../RowCards/OverviewLeads';
import Showings from '../ChartCards/Showings';
import TotalValueCard from '../TotalValueCard';
import PropertiesOperations from '../ChartCards/PropertiesOperations';
import PropertiesTypes from '../ChartCards/PropertiesTypes';
import PropertiesLocations from '../ChartCards/PropertiesLocations';
import ConstructionAge from '../ChartCards/ConstructionAge';
import DevelopmentsTypes from '../ChartCards/DevelopmentsTypes';
import DevelopmentsLocations from '../ChartCards/DevelopmentsLocations';
import EntryDate from '../ChartCards/EntryDate';
import PropertiesLastUpdate from '../ChartCards/PropertiesLastUpdate';
import ContactsLastUpdate from '../ChartCards/ContactsLastUpdate';
import QPrecoMarketplace from '../../DashboardPendings/QPrecoMarketplace';
import MarketplaceRegistrationQuality from '../../DashboardPendings/MarketplaceRegistrationQuality';
import { PROPERTIES_STATUS } from '../../constants';
import miniCardsStyles from '../../DashboardMiniCards/dashboardMiniCards.module.scss';

export const componentsMap = {
  mini_cards: {
    ActiveContacts: ContactsMiniCard,
    Properties: PropertiesMiniCard,
    AvailableDevelopments: DevelopmentsMiniCard,
  },
  CountActiveContacts: {
    ContactSource,
    Leads: OverviewLeads,
    PendingScheduledEvents,
    Showings,
    ContactsLastUpdate,
  },
  CountAvailableProperties: {
    TotalValueCurrency: TotalValueCard,
    Operation: PropertiesOperations,
    PropertyType: PropertiesTypes,
    Location: PropertiesLocations,
    ConstructionAge,
    EntryDate,
    PropertiesLastUpdate,
    QPrecoMarketplace,
    MarketplaceRegistrationQuality,
  },
  CountAvailableDevelopments: {
    DevelopmentType: DevelopmentsTypes,
    CountDevelopmentsInLocations: DevelopmentsLocations,
  },
};

export const PROPERTIES_TEXTS = {
  [PROPERTIES_STATUS.AVAILABLE]: 'CountAvailableProperties',
  [PROPERTIES_STATUS.APPRAISAL]: 'CountAppraisingProperties',
  [PROPERTIES_STATUS.RESERVED]: 'CountReservedProperties',
};

export const LIST_CLASSNAMES = {
  mini_cards: miniCardsStyles.dashboardMiniCards,
};

export const SECTION_TYPES = {
  mini_cards: 'kpicard',
};
